export default "__VITE_ASSET__Cg$iqCQK__"